import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CreateContactDialogComponent } from 'src/app/lib/customer/components/dialog/create-contact-dialog/create-contact-dialog.component';
import { DOUBLET_PROVIDER_SERVICE } from 'src/app/lib/shared/interfaces';
import { Contract } from '../../../classes';
import { ContractService } from '../../../services/contract.service';
import { CreateContractService } from '../../../services/create-contract-service';

@Component({
  selector: 'app-create-contract-dialog',
  templateUrl: './create-contract-dialog.component.html',
  styleUrls: ['./create-contract-dialog.component.css'],
  providers: [
    { provide: DOUBLET_PROVIDER_SERVICE, useClass: CreateContractService }
  ]
})
export class CreateContractDialogComponent implements OnInit {

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(DOUBLET_PROVIDER_SERVICE) public service: CreateContractService,
    private _ref: MatDialogRef<CreateContractDialogComponent>,
    private _formBuilder: FormBuilder,
    private _contractService: ContractService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    @Inject(MAT_DIALOG_DATA) private _data: CreateContractDialogComponentInputData
  ) {
    this.formGroup = this._formBuilder.group(new Contract());
  }

  close = () => this._ref.close();

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.service.doubletClicked$.subscribe(() => this.close())
    ]);
    if(this._data.patchValue) this.formGroup.patchValue(this._data.patchValue);
  }

  saveContract() {
    if (this.formGroup.invalid) return;
    this._contractService.createContract(this.formGroup.value, null).subscribe(
      (contract: Contract) => {
        if(!this._data.preventNavigation) this._router.navigate(['/contract-details', contract.contractid]);
        this._ref.close(contract);
      },
      (error: HttpErrorResponse) => this._snackBar.open(`Fehler beim Erstellen des Vertrags (${error.message})`, 'Abbrechen')
    );
  }

}

export class CreateContractDialogComponentInputData {
  preventNavigation: boolean;
  patchValue: Contract;
}
